import { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useGlobal } from '../contexts/GlobalContext';
import React from 'react';
import SetupInstructions from './admin/SetupInstructions';
import { Container } from 'react-bootstrap';

const Setup: React.FC = () => {
    const { user } = useGlobal();

    useEffect(() => {
        const signUserOut = async () => {
            if (user) {
                await signOut(auth);
            }
        };

        signUserOut();
    }, [user]);

    return (
<Container>
  <img style={{ maxHeight: '6vw', marginTop:"25px", float:"right", maxWidth:'250px' }} src='/logo-blue.png' alt='Logo' />
  <SetupInstructions />
</Container>

    );
};

export default Setup;